import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { FiEye } from 'react-icons/fi'
import Card from '../../../../components/Card'
import { api, authHeaders } from '../../../../services/api'
import Table from '../../../../components/Table'
import Modal from '../../../../components/Modal'
import masks from '../../../../util/masks'

export default function () {
	const [pessoaFaturaDetalhes, setPessoaFaturaDetalhes] = useState(null)

	const { data: pessoasComFatura } = useQuery({
		queryKey: ['busca-pessoas-com-faturas'],
		queryFn: async () => {
			const response = await api.get('pessoa_fatura', authHeaders())

			return response
		}
	})

	const { data: faturasDaPessoa } = useQuery({
		queryKey: ['busca-faturas-da-pessoa'],
		queryFn: async () => {
			const response = await api.get(`fatura/${pessoaFaturaDetalhes.id}`, authHeaders())

			return response.faturas
		},
		enabled: !!pessoaFaturaDetalhes,
		initialData: []
	})

	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:mx-32 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-4">Faturas</h1>

				<Table 
					headers={[
						{ name: 'nome', value: 'Nome' },
						{ name: 'quantidade_faturas', value: 'Total faturas' },
						{ name: 'quantidade_pendentes', value: 'Faturas pendentes' },
						{ name: 'quantidade_pagas', value: 'Faturas pagas' }
					]}
					data={pessoasComFatura}
					actions={[
						{
							action: setPessoaFaturaDetalhes,
							icon: FiEye,
							iconSize: 16,
							name: 'Explorar'
						}
					]}
				/>
			</Card>

			<Modal
				isOpen={!!pessoaFaturaDetalhes}
				handleClose={() => {
					setPessoaFaturaDetalhes(null)
				}}
				title={`Faturas de ${pessoaFaturaDetalhes?.nome}`}
			>
				{faturasDaPessoa && (
					<Table 
						headers={[
							{ name: 'valor', value: 'Valor', centered: true },
							{ name: 'status', value: 'Status', centered: true },
							{ name: 'id_mercado_pago', value: 'ID Merc. Pago', centered: true },
							{ name: 'data_criacao', value: 'Data de criação', centered: true },
							{ name: 'data_vencimento', value: 'Data de vencimento', centered: true },
							{ name: 'data_pagamento', value: 'Data de pagamento', centered: true }
						]}
						data={faturasDaPessoa.map(item => ({
							...item,
							data_criacao: format(new Date(item.data_criacao), 'dd/MM/yyyy HH:mm\'h\''),
							data_vencimento: format(new Date(item.data_vencimento), 'dd/MM/yyyy HH:mm\'h\''),
							data_pagamento: item.data_pagamento ? format(new Date(item.data_pagamento), 'dd/MM/yyyy HH:mm\'h\'') : '-',
							valor: masks.maskApply.currency(item.valor / 100),
							status: item.status === 'approved' ? 'pago' : 'pendente'
						}))}
					/>
				)}
			</Modal>
		</div>
	)
}
